/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable complexity */
/* eslint-disable radix */
/* eslint-disable max-statements*/
/* eslint-disable no-negated-condition*/
/* eslint-disable vars-on-top */
/* eslint-disable xss/no-mixed-html */
/* eslint-disable xss/no-location-href-assign */
/* eslint-disable sonarjs/no-identical-functions*/
/* eslint-disable no-ternary */
ACC.dealDetailsPage = {
  mainUnitPrice: 'mainUnitPrice',
  dealPriceSectionCls: 'ph-dealprices-section',
  subtotalPriceCls: 'ph-subtotalPrice',
  dealQuantityContainerCls: 'ph-dealQuantityContainer',
  prodDetailsDeal: 'ph-prodDetailsDeal',
  hiddenCls: 'hidden',
  maindealCheckbox: 'ph-dealCheck',
  dealBenefitCheckbox: 'ph-dealBenefitCheck',
  qtyboxDealCls: 'ph-return-qtybox-deal',
  curDealType: $('#ph-curDealType').val(),
  dealsBenefitProducts: 'ph-dealsBenefitProducts',
  keypressTimeoutVar: '',
  $keypressQtyInpEle: '',
  loadPriceConditioncheckfordeal: function(resultList, indx, dealProductCode, prodRowEle) {
    // Var product = resultList[indx],
    var filterProductList = resultList.filter(function(obj) {
          return obj.code === dealProductCode;
        }),
        /* Commenting below line as it is not used
        product = filterProductList[0], */
        priceList = filterProductList[0].priceList,
        /* Commenting below line as it is not used
        prodRow = '#ph-prod_row_', */
        curquantity = 0,
        priceValue = 0,
        discountedPrice = parseFloat($(prodRowEle).find('.ph-discountedPrice').val()),
        discountType = $(prodRowEle).find('.ph-discountType').val();

    if (priceList.length > 0) {
      var pricesHtml = '',
          addStrikeClass = '',
          priceAddedFlag = false;

      for (var priceIndex = 0; priceIndex < priceList.length; priceIndex = priceIndex + 1) {
        var priceRow = priceList[priceIndex];

        addStrikeClass = '';

        if (priceRow.priceType === 'FROM') {
          addStrikeClass = 'ph-strikeprice';
          pricesHtml = pricesHtml + ('<span class="ph-prodprice ' + addStrikeClass + '">' + priceRow.value.toFixed(2) + '</span>');
        } else if (priceRow.priceType === 'BUY' && priceRow.pricingConditionCode !== 'YLRR' && !priceAddedFlag) {
          pricesHtml = pricesHtml + ('<span class="ph-prodprice">' + priceRow.value.toFixed(2) + '</span>');
          priceAddedFlag = true;
        } else if (priceRow.value === null && pricesHtml === '') {
          pricesHtml = pricesHtml + '<span class="ph-prodprice">0.00</span>';
        }
      }

      $(prodRowEle).find('.' + ACC.dealDetailsPage.dealPriceSectionCls).html(pricesHtml);

      var productUnitPrice = parseFloat($(prodRowEle).find('.ph-prodprice').text());

      if (discountType === '%' && productUnitPrice !== 0) {
        var discountedPricePer = 0;

        if (discountedPrice > 0 && discountedPrice <= 99) {
          discountedPricePer = (productUnitPrice - ((parseFloat(discountedPrice) / 100) * productUnitPrice).toFixed(2)).toFixed(2);
        } else if (discountedPrice === 100) {
          discountedPricePer = '0.00';
        } else {
          discountedPricePer = '0.00';
        }

        $(prodRowEle).find('.ph-' + ACC.dealDetailsPage.mainUnitPrice).addClass('ph-strikeOrgPrice');
        $(prodRowEle).find('.ph-mainUnitPrice .ph-dealprices-section').removeClass(ACC.dealDetailsPage.dealPriceSectionCls);
        $(prodRowEle).find('.ph-upStrikePrice .ph-prodprice').text(discountedPricePer);
        $(prodRowEle).find('.ph-upStrikePrice').removeClass(ACC.dealDetailsPage.hiddenCls);
      } else if (discountType !== '%' && !isNaN(discountedPrice) && discountedPrice !== 100 && productUnitPrice !== 0) {
        $(prodRowEle).find('.ph-' + ACC.dealDetailsPage.mainUnitPrice).addClass('ph-strikeOrgPrice');
        $(prodRowEle).find('.ph-mainUnitPrice .ph-dealprices-section').removeClass(ACC.dealDetailsPage.dealPriceSectionCls);
        $(prodRowEle).find('.ph-upStrikePrice .ph-prodprice').text(discountedPrice.toFixed(2));
        $(prodRowEle).find('.ph-upStrikePrice').removeClass(ACC.dealDetailsPage.hiddenCls);
      }

      curquantity = parseInt($(prodRowEle).find('.' + ACC.dealDetailsPage.qtyboxDealCls).val());
      priceValue = parseFloat($(prodRowEle).find('.' + ACC.dealDetailsPage.dealPriceSectionCls).text());
      $(prodRowEle).find('.' + ACC.dealDetailsPage.subtotalPriceCls).html((curquantity * priceValue).toFixed(2));
      $('.ph-overlay').hide();
    }
  },
  loadStockCheckfordeal: function(resultList) {
    var $plRowEl = $('.ph-prod_row_' + resultList.code),
        nobackorderprod = $('#ph-nobackorderprod').val(),
        dChainProductToggle = $('.ph-dchain-product-toggle').val(),
        dChainProductValue = resultList.dchainValue,
        dChainProdValidFrom = resultList.validFrom,
        dChainFirstEntry = ACC.common.getDChainFirstEntry(resultList),
        dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
        // eslint-disable-next-line compat/compat
        dChainFirstEntryQty = dChainFirstEntry !== null ? parseInt(Object.values(dChainFirstEntry)[0], 0) : '';

    $plRowEl.each(function() {
      $(this).find('.ph-stock-qty-low').val(resultList.atpData.lowStockQty);
      $(this).find('.ph-stock-qty-max').val(resultList.atpData.maxStockQty);
      $(this).find('.ph-stock-availability').val(resultList.atpData.availabilityCode);

      if (resultList.atpData.availabilityCode === 'red' && nobackorderprod === 'true') {
        $(this).find('.' + ACC.dealDetailsPage.dealQuantityContainerCls).addClass(ACC.dealDetailsPage.hiddenCls);
        $(this).find('.ph-dealOutofstockBtn').removeClass(ACC.dealDetailsPage.hiddenCls);
      } else {
        $(this).find('.ph-dealOutofstockBtn').addClass(ACC.dealDetailsPage.hiddenCls);
        $(this).find('.' + ACC.dealDetailsPage.dealQuantityContainerCls).removeClass(ACC.dealDetailsPage.hiddenCls);
      }

      $(this).find('.ph-dchain-value').val(dChainProductValue);
      $(this).find('.ph-dchain-valid-from').val(dChainProdValidFrom);
      $(this).find('.ph-dchain-firstentry-date').val(dChainFirstEntryDate);
      $(this).find('.ph-dchain-firstentry-qty').val(dChainFirstEntryQty);

      /* Dchain implementation start */

      if (dChainProductToggle === 'true' && dChainProductValue !== '' && dChainProductValue !== null) {
        if (dChainProductValue === '30') {
          if ((nobackorderprod === 'true' && resultList.atpData.availabilityCode === 'red') ||
            !(ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))
          ) {
            $(this).addClass('ph-d-none');
          }
        } else if (dChainProductValue === '50') {
          if ((resultList.atpData.availabilityCode === 'red') || (!ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate) && (dChainFirstEntryQty === '' || dChainFirstEntryQty <= 0))) {
            $(this).addClass('ph-d-none');
          }
        }
      }

      /* Dchain implementation end */
    });
  },
  addBundleProductsToCart: function(productList, freeProductList) {
    var dealNumber = $('#ph-curDealNumber').val();

    $.ajax({
      url: ACC.config.encodedContextPath + '/deals-cart/add/multiple',
      data: {
        products: productList.toString(),
        freeProducts: freeProductList.toString(),
        dealNumber: dealNumber
      },
      type: 'POST',
      Datatype: 'json',
      success: function(cartResult) {
        if (cartResult === 'success') {
          window.location.href = ACC.config.encodedContextPath + '/cart';
        }
      }
    });
  },
  checkIfAnyProductInSectionIsLowInStock: function(dealSection) {
    var nobackorderprod = $('#ph-nobackorderprod').val(),
        $dealsSection = $(dealSection),
        isAnyProductMoreThanLowStock = false,
        dChainProductToggle = $('.ph-dchain-product-toggle').val();

    $dealsSection.each(function() {
      var $qtyInpBoxList = $(this).find('.ph-return-qtybox-deal');

      $qtyInpBoxList.each(function() {
        var qtyBoxVal = parseInt($(this).val()),
            $currentProductRow = $(this).closest('.ph-prodDetailsDeal'),
            productAvailability = $currentProductRow.find('.ph-stock-availability').val(),
            productLowStockQty = $currentProductRow.find('.ph-stock-qty-low').val(),
            dChainProductValue = $currentProductRow.find('.ph-dchain-value').val(),
            dChainFirstEntryQty = $currentProductRow.find('.ph-dchain-firstentry-qty').val();

        if ((nobackorderprod === 'true' && productAvailability !== 'green' && qtyBoxVal > productLowStockQty) ||
      (dChainProductToggle === 'true' && nobackorderprod === 'true' && dChainProductValue === '30' && qtyBoxVal > dChainFirstEntryQty) ||
    (dChainProductToggle === 'true' && dChainProductValue === '50' && qtyBoxVal > dChainFirstEntryQty)) {
          isAnyProductMoreThanLowStock = true;
        }
      });
    });

    return isAnyProductMoreThanLowStock;
  },
  checkIfMainDealSectionIsSatisfied: function(dealSection, min, max) {
    var totalQtySectionWise = 0,
        isAnyProductLowInStock = true,
        firstBundleDealSectionCheckbox = false;

    dealSection.find('.ph-return-qtybox-deal').each(function() {
      if (!isNaN($(this).val()) && $(this).val().length !== 0) {
        totalQtySectionWise = totalQtySectionWise + parseFloat($(this).val());
      }
    });

    isAnyProductLowInStock = ACC.dealDetailsPage.checkIfAnyProductInSectionIsLowInStock(dealSection);

    firstBundleDealSectionCheckbox = !dealSection.hasClass('ph-grp-number-1') ? $('.ph-dealsMainProducts.ph-grp-number-1').find('.' + ACC.dealDetailsPage.maindealCheckbox).is(':checked') : true;

    if (totalQtySectionWise >= min && totalQtySectionWise <= max && firstBundleDealSectionCheckbox && !isAnyProductLowInStock) {
      dealSection.find('.' + ACC.dealDetailsPage.maindealCheckbox).attr('checked', 'checked').prop('checked', true);
    } else {
      dealSection.find('.' + ACC.dealDetailsPage.maindealCheckbox).removeAttr('checked').prop('checked', false);
    }
  },
  commonfunChangeClk: function(curElm) {
    var sum = 0,
        // Commenting as not required sumSec = 0,
        sumBenefit = 0,
        remainderQty = 0,
        multipleedNum = 0,
        /* Commenting as it is not required
        maxAllowed = 0, */
        minQtyDeal = 0,
        maxQtyDeal = 0,
        /* Commenting as it is not required
        benefitMinQtyDeal = parseInt($('.ph-benefitMinQtyDeal').val()), */
        benefitMaxQtyDeal = parseInt($('.ph-benefitMaxQtyDeal').val()),
        maxBenefitQtyAllowed = 0,
        curClkParentElm = '',
        currentProductRow = $(curElm).closest('.ph-prodDetailsDeal'),
        isAnyProductLowInStock = false,
        qtyBoxBenefitSectionForBundles = '',
        dealMainProductSection = '';

    if (ACC.dealDetailsPage.curDealType === 'BUY_X_GET_ONE') {
      minQtyDeal = parseInt($(curElm).closest('.ph-dealsDescription_product_section').find('.ph-dealsMainProducts .ph-minQtyDeal').val());
      maxQtyDeal = parseInt($(curElm).closest('.ph-dealsDescription_product_section').find('.ph-dealsMainProducts .ph-maxQtyDeal').val());
      curClkParentElm = $(curElm).closest('.ph-dealsDescription_product_section').find('.ph-dealsMainProducts');
      $('.ph-dealsMainProducts .ph-return-qtybox-deal').each(function() {
        if (!isNaN($(this).val()) && $(this).val().length !== 0) {
          sum = sum + parseFloat($(this).val());
        }
      });
      $('.ph-updatedMinqtychoosen').text(sum);

      multipleedNum = Math.floor(sum / minQtyDeal);

      if (sum <= maxQtyDeal) {
        if (sum <= minQtyDeal) {
          $('.ph-maxThresholdQty').text(minQtyDeal);
        } else {
          $('.ph-maxThresholdQty').text(multipleedNum * minQtyDeal);
        }
      }

      remainderQty = sum % minQtyDeal;

      isAnyProductLowInStock = ACC.dealDetailsPage.checkIfAnyProductInSectionIsLowInStock($(curElm).closest('.ph-dealsDescription_product_section').find('.ph-dealsMainProducts'));

      if (sum >= minQtyDeal && sum <= maxQtyDeal && remainderQty === 0 && !isAnyProductLowInStock) {
        $(curClkParentElm).find('.' + ACC.dealDetailsPage.maindealCheckbox).attr('checked', 'checked').prop('checked', true);
      } else {
        $(curClkParentElm).find('.' + ACC.dealDetailsPage.maindealCheckbox).removeAttr('checked').prop('checked', false);
      }

      $('.ph-dealsBenefitProducts .ph-return-qtybox-deal').each(function() {
        if (!isNaN($(this).val()) && $(this).val().length !== 0) {
          sumBenefit = sumBenefit + parseFloat($(this).val());
        }
      });
      $('.ph-updatedBenefitMinqtychoosen').text(sumBenefit);

      maxBenefitQtyAllowed = multipleedNum < benefitMaxQtyDeal ? multipleedNum : benefitMaxQtyDeal;
      $('.ph-benefitThresholdQty').text(maxBenefitQtyAllowed);

      isAnyProductLowInStock = ACC.dealDetailsPage.checkIfAnyProductInSectionIsLowInStock($('.ph-dealsBenefitProducts'));

      if (sumBenefit !== 0 && sumBenefit === maxBenefitQtyAllowed && !isAnyProductLowInStock) {
        $('.' + ACC.dealDetailsPage.dealBenefitCheckbox).attr('checked', 'checked').prop('checked', true);
      } else {
        $('.' + ACC.dealDetailsPage.dealBenefitCheckbox).removeAttr('checked').prop('checked', false);
      }
    }

    if (ACC.dealDetailsPage.curDealType === 'BUNDLE_STATIC') {
      var mainDealTotalQty = 0;

      minQtyDeal = parseInt($(curElm).parents('.ph-dealsMainProducts').find('.ph-minQtyDeal').val());
      maxQtyDeal = parseInt($(curElm).parents('.ph-dealsMainProducts').find('.ph-maxQtyDeal').val());
      dealMainProductSection = $('.ph-dealsMainProducts.ph-grp-number-1');
      curClkParentElm = $(curElm).parents('.ph-dealsMainProducts');

      dealMainProductSection.find('.ph-return-qtybox-deal').each(function() {
        if (!isNaN($(this).val()) && $(this).val().length !== 0) {
          mainDealTotalQty = mainDealTotalQty + parseFloat($(this).val());
        }
      });

      $('.ph-dealsMainProducts').each(function() {
        var $mainProductSection = $(this),
            totalProductCount = 0,
            sectionTotalQty = 0;

        // Execute below function only for 2 to n sections and avoiding 1st section
        if (!$mainProductSection.hasClass('ph-grp-number-1')) {
          var setNumberArr = [],
              distinctSetNumber = [];

          $mainProductSection.find('.ph-set-number').each(function() {
            setNumberArr.push($(this).val());
          });

          distinctSetNumber = setNumberArr.filter(function(item, index) {
            return setNumberArr.indexOf(item) === index;
          });

          $mainProductSection.find('.ph-total-max-qty-allowed').text(mainDealTotalQty);

          if (distinctSetNumber.length !== 1 || $mainProductSection.find('.ph-return-qtybox-deal').length === 1) {
            $mainProductSection.find('.ph-return-qtybox-deal').each(function() {
              $(this).val(mainDealTotalQty);
              totalProductCount = totalProductCount + 1;
              ACC.dealDetailsPage.updateQuantityBoxForBundleAndBuyXGet($(this).closest('.ph-quantity-input-container').first(), $(this));

              if (mainDealTotalQty > 0) {
                $(this).attr('disabled', true).siblings('.ph-list_plusminus').addClass('ph-disable-button');
              }
            });

            if ($mainProductSection.find('.ph-return-qtybox-deal').length === 1) {
              $mainProductSection.find('.ph-maxQtyDeal').val(mainDealTotalQty);
              $mainProductSection.find('.ph-total-added-qty').text(mainDealTotalQty);
            }

            ACC.dealDetailsPage.checkIfMainDealSectionIsSatisfied($mainProductSection, mainDealTotalQty * totalProductCount, mainDealTotalQty * totalProductCount);
          } else {
            $mainProductSection.find('.ph-return-qtybox-deal').each(function() {
              if (!isNaN($(this).val()) && $(this).val().length !== 0) {
                sectionTotalQty = sectionTotalQty + parseFloat($(this).val());
              }
            });
            $mainProductSection.find('.ph-maxQtyDeal').val(mainDealTotalQty);
            $mainProductSection.find('.ph-total-added-qty').text(sectionTotalQty);
            ACC.dealDetailsPage.checkIfMainDealSectionIsSatisfied($mainProductSection, mainDealTotalQty, mainDealTotalQty);
          }
        } else {
          ACC.dealDetailsPage.checkIfMainDealSectionIsSatisfied($mainProductSection, dealMainProductSection.find('.ph-minQtyDeal').val(), dealMainProductSection.find('.ph-maxQtyDeal').val());
        }
      });

      $(curClkParentElm).find('.ph-return-qtybox-deal').each(function() {
        if (!isNaN($(this).val()) && $(this).val().length !== 0) {
          sum = sum + parseFloat($(this).val());
        }
      });
      $(curClkParentElm).find('.ph-current-selected-qty').text(sum);

      /* Commenting
      $('.ph-dealsMainProducts .ph-return-qtybox-deal').each(function() {
        if (!isNaN($(this).val()) && $(this).val().length !== 0) {
          sumSec = sumSec + parseFloat($(this).val());
        }
      });
      */

      /* Start of checking quantity and setting checkbox value
      if ($(curElm).closest('.ph-dealsMainProducts').length > 0) {
        isAnyProductLowInStock = ACC.dealDetailsPage.checkIfAnyProductInSectionIsLowInStock($(curElm).closest('.ph-dealsDescription_product_section').find('.ph-dealsMainProducts'));

        if (sum >= minQtyDeal && sum <= maxQtyDeal && !isAnyProductLowInStock) {
          $(curClkParentElm).find('.' + ACC.dealDetailsPage.maindealCheckbox).attr('checked', 'checked').prop('checked', true);
        } else {
          $(curClkParentElm).find('.' + ACC.dealDetailsPage.maindealCheckbox).removeAttr('checked').prop('checked', false);
        }
      }
       End of checking quantity and setting checkbox value */

      /* Commeting to change benefit quantity products qty from max to 1st section qty
      benefitMaxQtyDeal = parseInt($('.ph-dealsBenefitProducts').find('.ph-benefitMaxQtyDeal').val()); */
      benefitMaxQtyDeal = mainDealTotalQty;

      if ($('input.ph-dealCheck').not(':checked').length === 0) {
        $('.' + ACC.dealDetailsPage.dealsBenefitProducts).find('.ph-return-qtybox-deal').val(benefitMaxQtyDeal);
        $('.' + ACC.dealDetailsPage.dealsBenefitProducts).find('.ph-sameMainQty').text(benefitMaxQtyDeal);
      } else {
        $('.' + ACC.dealDetailsPage.dealsBenefitProducts).find('.ph-return-qtybox-deal').val(0);
        $('.' + ACC.dealDetailsPage.dealsBenefitProducts).find('.ph-sameMainQty').text(0);
      }


      isAnyProductLowInStock = ACC.dealDetailsPage.checkIfAnyProductInSectionIsLowInStock($('.ph-dealsBenefitProducts'));

      if ($('input.ph-dealCheck').not(':checked').length === 0 && !isAnyProductLowInStock) {
        $('.' + ACC.dealDetailsPage.dealBenefitCheckbox).attr('checked', 'checked').prop('checked', true);
      } else {
        $('.' + ACC.dealDetailsPage.dealBenefitCheckbox).removeAttr('checked').prop('checked', false);
      }


      /* Start of show low stock quantity for benefit section in Bundle static deal */
      qtyBoxBenefitSectionForBundles = $('.ph-dealsBenefitProducts .ph-return-qtybox-deal');
      qtyBoxBenefitSectionForBundles.each(function() {
        var $currentProductRow = $(this).closest('.ph-prodDetailsDeal');

        ACC.dealDetailsPage.showMaxQuantityAllowedPopup($currentProductRow);
      });
      /* End of show low stock quantity for benefit section in Bundle static deal */

      $('.ph-dealsBenefitProducts .ph-sameMainQty').each(function() {
        var quantity = parseInt($(this).text()),
            prodPriceValue = parseFloat($(this).parents('.' + ACC.dealDetailsPage.prodDetailsDeal).find('.' + ACC.dealDetailsPage.dealPriceSectionCls).text());

        $(this).parents('.' + ACC.dealDetailsPage.prodDetailsDeal).find('.' + ACC.dealDetailsPage.subtotalPriceCls).html((quantity * prodPriceValue).toFixed(2));
      });
    }

    ACC.dealDetailsPage.showMaxQuantityAllowedPopup(currentProductRow);

    ACC.dealDetailsPage.checkAndEnableCartButtonForBundle();
  },
  checkAndEnableCartButtonForBundle: function() {
    if ($('.ph-deal-section-checkbox:checkbox:checked').length === $('.ph-deal-section-checkbox').length && $('.ph-sap-orderBlock').length === 0) {
      $('.ph-dealAddToCartBtn').removeClass('ph-disable-button');
    } else {
      $('.ph-dealAddToCartBtn').addClass('ph-disable-button');
    }
  },
  updateQuantityBox: function($qtyInpContainer, $currentActionEle) {
    var qtyInpBox = $qtyInpContainer.find('.ph-return-qtybox-deal'),
        nextValue = 0,
        curSelectedQty = 0,
        newSelectedQty = 0,
        currentProductRow = $qtyInpContainer.closest('.ph-prodDetailsDeal');

    // eslint-disable-next-line no-nested-ternary
    nextValue = $currentActionEle.hasClass('ph-deal_qtyminus') ? -1 : $currentActionEle.hasClass('ph-deal_qtyplus') ? 1 : 0;

    curSelectedQty = parseInt(qtyInpBox.val());
    newSelectedQty = curSelectedQty + nextValue;

    if (nextValue === 1 || nextValue === -1) {
      if (newSelectedQty === 0) {
        qtyInpBox.val(parseInt(newSelectedQty));
        $currentActionEle.addClass('ph-disable-button');
      } else {
        qtyInpBox.val(parseInt(newSelectedQty));
        $qtyInpContainer.find('.ph-list_plusminus').removeClass('ph-disable-button');
      }
    } else if (nextValue === 0) {
      if (curSelectedQty === 0) {
        qtyInpBox.val(0);
        $qtyInpContainer.find('.ph-deal_qtyminus').addClass('ph-disable-button');
      } else {
        qtyInpBox.val(curSelectedQty);
        $qtyInpContainer.find('.ph-list_plusminus').removeClass('ph-disable-button');
      }
    }

    ACC.dealDetailsPage.showMaxQuantityAllowedPopup(currentProductRow);

    ACC.dealDetailsPage.updateSubTotalPrice($currentActionEle.closest('.ph-prodDetailsDeal').first());
    ACC.dealDetailsPage.updateTotalSelectedQtyInHeader($currentActionEle.closest('.ph-dealsMainProducts').first());
  },
  updateSubTotalPrice: function($currentProdRow) {
    var $productDealMain = $currentProdRow.closest('.ph-dealsMainProducts').find('.ph-prodDetailsDeal'),
        totalSumQty = 0;

    for (var lenQty = 0; lenQty < $productDealMain.length; lenQty = lenQty + 1) {
      totalSumQty = totalSumQty + parseInt($($productDealMain[lenQty]).find('.ph-return-qtybox-deal').val());
    }

    for (var lenProd = 0; lenProd < $productDealMain.length; lenProd = lenProd + 1) {
      var productUnitPrice = 0,
          $currentProductDealRow = $($productDealMain[lenProd]),
          productMainUnitPrice = parseFloat($currentProductDealRow.find('.ph-mainUnitPrice .ph-prodprice').text()),
          currentProductRowQty = parseInt($currentProductDealRow.find('.ph-return-qtybox-deal').val()),
          $priceRangeGroupList = $currentProductDealRow.find('.ph-combo-price-range'),
          priceSet = false;

      for (var priceRangeLen = 0; priceRangeLen < $priceRangeGroupList.length; priceRangeLen = priceRangeLen + 1) {
        var $currentPriceRange = $($priceRangeGroupList[priceRangeLen]),
            priceRangeMinQty = $currentPriceRange.data('minqty'),
            priceRangeMaxQty = $currentPriceRange.data('maxqty'),
            priceRangeDiscountType = '',
            priceRangeDiscountValue = '';

        if (!priceSet) {
          if (totalSumQty >= priceRangeMinQty && totalSumQty <= priceRangeMaxQty) {
            priceRangeDiscountType = $currentPriceRange.data('discounttype');
            priceRangeDiscountValue = parseFloat($currentPriceRange.data('discountprice'));

            // eslint-disable-next-line max-depth
            if (priceRangeDiscountType === '%') {
              var discountedPricePerUnit = 0;

              // eslint-disable-next-line max-depth
              if (priceRangeDiscountValue > 0 && priceRangeDiscountValue <= 99) {
                discountedPricePerUnit = (productMainUnitPrice - ((parseFloat(priceRangeDiscountValue) / 100) * productMainUnitPrice).toFixed(2)).toFixed(2);
              } else if (priceRangeDiscountValue === 100) {
                discountedPricePerUnit = '0.00';
              } else {
                discountedPricePerUnit = '';
              }

              $currentProductDealRow.find('.ph-' + ACC.dealDetailsPage.mainUnitPrice).addClass('ph-strikeOrgPrice');
              $currentProductDealRow.find('.ph-mainUnitPrice .ph-dealprices-section').removeClass(ACC.dealDetailsPage.dealPriceSectionCls);
              $currentProductDealRow.find('.ph-upStrikePrice .ph-prodprice').text(discountedPricePerUnit).parent().addClass(ACC.dealDetailsPage.dealPriceSectionCls);
              $currentProductDealRow.find('.ph-upStrikePrice').removeClass(ACC.dealDetailsPage.hiddenCls);
            } else if (priceRangeDiscountType !== '%') {
              $currentProductDealRow.find('.ph-' + ACC.dealDetailsPage.mainUnitPrice).addClass('ph-strikeOrgPrice');
              $currentProductDealRow.find('.ph-mainUnitPrice .ph-dealprices-section').removeClass(ACC.dealDetailsPage.dealPriceSectionCls);
              $currentProductDealRow.find('.ph-upStrikePrice .ph-prodprice').text(priceRangeDiscountValue.toFixed(2)).parent().addClass(ACC.dealDetailsPage.dealPriceSectionCls);
              $currentProductDealRow.find('.ph-upStrikePrice').removeClass(ACC.dealDetailsPage.hiddenCls);
            }

            priceSet = true;
          } else {
            $currentProductDealRow.find('.ph-' + ACC.dealDetailsPage.mainUnitPrice).removeClass('ph-strikeOrgPrice');
            $currentProductDealRow.find('.ph-mainUnitPrice .ph-prodprice').parent().addClass(ACC.dealDetailsPage.dealPriceSectionCls);
            $currentProductDealRow.find('.ph-upStrikePrice .ph-prodprice').text('');
            $currentProductDealRow.find('.ph-upStrikePrice .ph-dealprices-section').removeClass(ACC.dealDetailsPage.dealPriceSectionCls);
            $currentProductDealRow.find('.ph-upStrikePrice').addClass(ACC.dealDetailsPage.hiddenCls);
          }
        }
      }

      productUnitPrice = parseFloat($currentProductDealRow.find('.ph-dealprices-section .ph-prodprice').text());
      $currentProductDealRow.find('.ph-subtotalPrice').text((productUnitPrice * currentProductRowQty).toFixed(2));
    }

    ACC.dealDetailsPage.checkAndEnableAddToCartBtn();
  },
  updateTotalSelectedQtyInHeader: function($sectionEle) {
    var $qtyInpBoxList = $sectionEle.find('.ph-return-qtybox-deal'),
        totalSelectedQty = 0;

    $qtyInpBoxList.each(function() {
      totalSelectedQty = totalSelectedQty + parseInt($(this).val());
    });
    $sectionEle.find('.ph-current-selected-qty').text(totalSelectedQty);
  },
  checkAndEnableAddToCartBtn: function() {
    var $productListSection = $('.ph-dealsMainProducts'),
        $allDealChkBoxList = $('.' + ACC.dealDetailsPage.maindealCheckbox),
        nobackorderprod = $('#ph-nobackorderprod').val();

    $productListSection.each(function() {
      var $qtyInpBoxList = $(this).find('.ph-return-qtybox-deal'),
          qtyTotal = 0,
          minDealQty = parseInt($(this).find('.ph-minQtyDeal').val()),
          maxDealQty = parseInt($(this).find('.ph-maxQtyDeal').val()),
          isAnyProductMoreThanLowStock = false;

      $qtyInpBoxList.each(function() {
        var qtyBoxVal = parseInt($(this).val()),
            $currentProductRow = $(this).closest('.ph-prodDetailsDeal'),
            productAvailability = $currentProductRow.find('.ph-stock-availability').val(),
            productLowStockQty = $currentProductRow.find('.ph-stock-qty-low').val();

        qtyTotal = qtyTotal + qtyBoxVal;

        if (nobackorderprod === 'true' && productAvailability !== 'green' && qtyBoxVal > productLowStockQty) {
          isAnyProductMoreThanLowStock = true;
        }
      });

      if (qtyTotal >= minDealQty && qtyTotal <= maxDealQty && !isAnyProductMoreThanLowStock) {
        $(this).find('.' + ACC.dealDetailsPage.maindealCheckbox).attr('checked', 'checked').prop('checked', true);
      } else {
        $(this).find('.' + ACC.dealDetailsPage.maindealCheckbox).removeAttr('checked', 'checked').prop('checked', false);
      }
    });

    if ($allDealChkBoxList.length === $('.' + ACC.dealDetailsPage.maindealCheckbox + ':checked').length && $('.ph-sap-orderBlock').length === 0) {
      $('.ph-dealAddToCartBtn').removeClass('ph-disable-button');
    } else {
      $('.ph-dealAddToCartBtn').addClass('ph-disable-button');
    }
  },
  updateQuantityBoxForBundleAndBuyXGet: function($qtyInpContainer, $currentActionEle) {
    var qtyInpBox = $qtyInpContainer.find('.ph-return-qtybox-deal'),
        nextValue = 0,
        curSelectedQty = 0,
        newSelectedQty = 0,
        currentProductRow = $qtyInpContainer.closest('.ph-prodDetailsDeal'),
        quantity = 0,
        prodPriceValue = 0.0;

    // eslint-disable-next-line no-nested-ternary
    nextValue = $currentActionEle.hasClass('ph-deal_qtyminus') ? -1 : $currentActionEle.hasClass('ph-deal_qtyplus') ? 1 : 0;

    curSelectedQty = parseInt(qtyInpBox.val());
    newSelectedQty = curSelectedQty + nextValue;

    if (nextValue === 1 || nextValue === -1) {
      if (newSelectedQty === 0) {
        qtyInpBox.val(parseInt(newSelectedQty));
        $currentActionEle.addClass('ph-disable-button');
      } else {
        qtyInpBox.val(parseInt(newSelectedQty));
        $qtyInpContainer.find('.ph-list_plusminus').removeClass('ph-disable-button');
      }
    } else if (nextValue === 0) {
      if (curSelectedQty === 0) {
        qtyInpBox.val(0);
        $qtyInpContainer.find('.ph-deal_qtyminus').addClass('ph-disable-button');
      } else {
        qtyInpBox.val(curSelectedQty);
        $qtyInpContainer.find('.ph-list_plusminus').removeClass('ph-disable-button');
      }
    }

    ACC.dealDetailsPage.showMaxQuantityAllowedPopup(currentProductRow);

    quantity = parseInt($currentActionEle.parents('.' + ACC.dealDetailsPage.dealQuantityContainerCls).find('.' + ACC.dealDetailsPage.qtyboxDealCls).val());
    prodPriceValue = parseFloat($currentActionEle.parents('.' + ACC.dealDetailsPage.prodDetailsDeal).find('.' + ACC.dealDetailsPage.dealPriceSectionCls).text());

    $currentActionEle.parents('.' + ACC.dealDetailsPage.prodDetailsDeal).find('.' + ACC.dealDetailsPage.subtotalPriceCls).html((quantity * prodPriceValue).toFixed(2));
  },
  dealGaEvent: function(productListForGa) {
    var curDealNumber = $('#ph-curDealNumber').val();

    ACC.googleanalytics.gaEventsForLinks({
      url: window.location.protocol + '//' + window.location.host + ACC.config.encodedContextPath + '/deals/' + curDealNumber,
      description: 'Deal AddtoCart Button Click',
      trigger: 'dealAddToCartBtn.click',
      value: curDealNumber,
      compname: 'dealAddtoCartButton'
    });

    var eddlAction = {
      trigger: 'ecommerce.cart.add',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: window.eddlContext.locale.currency,
        add: {
          actionField: {
            list: 'dealItems'
          },
          products: productListForGa
        }
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },
  showMaxQuantityAllowedPopup: function(currentProductRow) {
    var enteredQty = parseInt(currentProductRow.find('.ph-return-qtybox-deal').val(), 0),
        nobackorderprod = $('#ph-nobackorderprod').val(),
        lowStockQty = currentProductRow.find('.ph-stock-qty-low').val(),
        productAvailability = currentProductRow.find('.ph-stock-availability').val(),
        lowestQtyName = '',
        maxQtyListArr = [],
        dChainProductToggle = $('.ph-dchain-product-toggle').val(),
        dChainProductValue = currentProductRow.find('.ph-dchain-value').val(),
        dChainFirstEntryQty = currentProductRow.find('.ph-dchain-firstentry-qty').val();

    if (nobackorderprod === 'true' && productAvailability !== 'green' && lowStockQty > 0) {
      maxQtyListArr.push({
        qtyName: 'lowStock',
        qtyValue: lowStockQty
      });
    }

    if (dChainProductToggle === 'true' && dChainProductValue === '50' && dChainFirstEntryQty > 0) {
      maxQtyListArr.push({
        qtyName: 'dChain50',
        qtyValue: dChainFirstEntryQty
      });
    }

    if (nobackorderprod === 'true' && dChainProductToggle === 'true' && dChainProductValue === '30' && dChainFirstEntryQty > 0) {
      maxQtyListArr.push({
        qtyName: 'dChain30',
        qtyValue: dChainFirstEntryQty
      });
    }

    currentProductRow.find('.ph-product-deal-lowqty').addClass('hidden');
    currentProductRow.find('.ph-product-deal-dchain-popup').addClass('hidden');

    lowestQtyName = ACC.common.getLowestQtyNameFromObjList(maxQtyListArr, enteredQty);

    if (lowestQtyName === 'lowStock') {
      var lowStockQtyMsg = currentProductRow.find('.ph-product-deal-lowqty').first().text();

      currentProductRow.find('.ph-product-deal-lowqty').html(lowStockQtyMsg.replace('{0}', lowStockQty)).removeClass('hidden');
    }

    if (lowestQtyName === 'dChain30' || lowestQtyName === 'dChain50') {
      var dChainQtyMsg = currentProductRow.find('.ph-product-deal-dchain-popup').first().text();

      currentProductRow.find('.ph-product-deal-dchain-popup').html(dChainQtyMsg.replace('{0}', dChainFirstEntryQty)).removeClass('hidden');
    }
  }
};
$(document).ready(function() {
  var dealTypeForLoad = $('#ph-curDealType').val();
  var prodCodes = [],
      // Commenting this line as it is not used sum = 0,
      prodCodesForPrice = [];

  if ($('.ph-dealsDescription_product_section').length > 0) {
    $('.ph-overlay').show();
    $('.' + ACC.dealDetailsPage.prodDetailsDeal).each(function(index, item) {
      var prodCode = $(item).attr('id').split('ph-prod_row_');

      if (prodCode) {
        prodCodes.push(prodCode[1]);
      }
    });

    if (prodCodes.length !== 0) {
      for (var prdIdx = 0; prdIdx < prodCodes.length; prdIdx = prdIdx + 1) {
        ACC.common.getAtpData(prodCodes[prdIdx], function(result) {
          if (result) {
            ACC.dealDetailsPage.loadStockCheckfordeal(result);
          }
        });
      }

      prodCodesForPrice = prodCodes.filter(function(item, index) {
        return prodCodes.indexOf(item) === index;
      });

      ACC.decisionPageInfiniteLoader.getPriceData(prodCodesForPrice, function(resultList) {
        var $dealMainProductList = $('.ph-dealsMainProducts .ph-prodHeader .ph-prodDetailsDeal'),
            $dealBenefitProductList = $('.ph-dealsBenefitProducts .ph-prodHeader .ph-prodDetailsDeal'),
            $allQuanityBox = $('.ph-return-qtybox-deal');

        if (Array.isArray(resultList) && resultList.length > 0) {
          for (var indx = 0; indx < $dealMainProductList.length; indx = indx + 1) {
            var dealProductCode = $($dealMainProductList[indx]).find('.ph-dealProductcode').val();

            ACC.dealDetailsPage.loadPriceConditioncheckfordeal(resultList, indx, dealProductCode, $dealMainProductList[indx]);
          }

          for (var index = 0; index < $dealBenefitProductList.length; index = index + 1) {
            var dealBenefitProductCode = $($dealBenefitProductList[index]).find('.ph-dealProductcode').val();

            ACC.dealDetailsPage.loadPriceConditioncheckfordeal(resultList, index, dealBenefitProductCode, $dealBenefitProductList[index]);
          }
          /* For (var indx = 0; indx < $resultList.length; indx = indx + 1) {
            ACC.dealDetailsPage.loadPriceConditioncheckfordeal(resultList, indx);
            } */
        }

        for (var qtyIndx = 0; qtyIndx < $allQuanityBox.length; qtyIndx = qtyIndx + 1) {
          // eslint-disable-next-line security/detect-object-injection
          $($allQuanityBox[qtyIndx]).trigger('change');
        }
      });
    }

    /* $('.' + ACC.dealDetailsPage.qtyboxDealCls).val(0); */

    $(document).on('click', '.ph-producHeaderbar', function() {
      if ($(this).hasClass('ph-icon-arrow-down')) {
        $(this).parent().find('.ph-productListContainer').removeClass(ACC.dealDetailsPage.hiddenCls);
        $(this).removeClass('ph-icon-arrow-down').addClass('ph-icon-arrow-up');
      } else {
        $(this).parent().find('.ph-productListContainer').addClass(ACC.dealDetailsPage.hiddenCls);
        $(this).removeClass('ph-icon-arrow-up').addClass('ph-icon-arrow-down');
      }
    });

    $(document).on('click', '.ph-dealAddToCartBtn', function() {
      var bundleProductList = [],
          freeProductList = [],
          productListForGa = [];

      $(this).addClass('ph-disable-button').prop('disabled', false);
      $('.ph-interstitial-loader').css('display', 'inline-block').removeClass('hidden');
      $('.' + ACC.dealDetailsPage.prodDetailsDeal).each(function() {
        var prodVal = $(this).attr('id').split('ph-prod_row_'),
            qtyVal = $(this).find('.' + ACC.dealDetailsPage.qtyboxDealCls).val(),
            // eslint-disable-next-line multiline-ternary
            grpNo = $(this).closest('.ph-productListContainer').find('.ph-main-deal-grp-number').length > 0
              ? $(this).closest('.ph-productListContainer').find('.ph-main-deal-grp-number').val() : '',
            productUnitPrice = parseFloat($(this).find('.ph-dealprices-section .ph-prodprice').text());

        if (qtyVal !== '0') {
          if (productUnitPrice !== 0) {
            bundleProductList.push(prodVal[1] + ':' + qtyVal + ':' + grpNo);
          } else if (productUnitPrice === 0) {
            freeProductList.push(prodVal[1] + ':' + qtyVal + ':' + grpNo);
          }
        }

        productListForGa.push({
          /* eslint-disable id-length */
          id: prodVal[1],
          /* eslint-enable id-length */
          locale: window.eddlContext.locale.code,
          quantity: qtyVal,
          price: productUnitPrice
        });
      });
      ACC.dealDetailsPage.addBundleProductsToCart(bundleProductList, freeProductList);
      ACC.dealDetailsPage.dealGaEvent(productListForGa);
    });

    if (dealTypeForLoad === 'BUNDLE_STATIC' || dealTypeForLoad === 'BUY_X_GET_ONE') {
      if (ACC.dealDetailsPage.curDealType === 'BUNDLE_STATIC') {
        $('.' + ACC.dealDetailsPage.dealsBenefitProducts).find('.ph-return-qtybox-deal');
        $('.' + ACC.dealDetailsPage.dealsBenefitProducts).find('.ph-sameMainQty');


        $('.ph-dealsMainProducts').each(function() {
          var $mainProductSection = $(this);

          if (!$mainProductSection.hasClass('ph-grp-number-1')) {
            var setNumberArr = [],
                distinctSetNumber = [];

            $mainProductSection.find('.ph-set-number').each(function() {
              setNumberArr.push($(this).val());
            });

            distinctSetNumber = setNumberArr.filter(function(item, index) {
              return setNumberArr.indexOf(item) === index;
            });

            $mainProductSection.find('.ph-total-max-qty-allowed').text('0');

            if (distinctSetNumber.length !== 1) {
              $mainProductSection.find('.ph-different-setnumber').removeClass('hidden');
            } else {
              $mainProductSection.find('.ph-same-setnumber').removeClass('hidden');
              $mainProductSection.find('.ph-total-added-qty').text('0');
            }
          }
        });
      }

      $(document).on('keyup', '.ph-return-qtybox-deal', function() {
        var quantity = parseInt($(this).val());

        if (!quantity) {
          quantity = 0;
          $(this).val(quantity);
        } else {
          $(this).val(quantity);
        }

        if (ACC.dealDetailsPage.keypressTimeoutVar) {
          clearTimeout(ACC.dealDetailsPage.keypressTimeoutVar);
          ACC.dealDetailsPage.keypressTimeoutVar = null;
        }

        ACC.dealDetailsPage.$keypressQtyInpEle = $(this);
        ACC.dealDetailsPage.keypressTimeoutVar = setTimeout(function() {
          ACC.dealDetailsPage.$keypressQtyInpEle.trigger('change');
        }, 750);
      });
      $(document).on('click', '.ph-dealCheck', function(event) {
        event.stopPropagation();

        return false;
      });
      $(document).on('change', '.ph-return-qtybox-deal', function() {
        ACC.dealDetailsPage.updateQuantityBoxForBundleAndBuyXGet($(this).closest('.ph-quantity-input-container').first(), $(this));
        ACC.dealDetailsPage.commonfunChangeClk(this);
      });

      $(document).on('click', '.ph-prodDetailsDeal .ph-list_plusminus', function() {
        ACC.dealDetailsPage.updateQuantityBoxForBundleAndBuyXGet($(this).closest('.ph-quantity-input-container').first(), $(this));
        ACC.dealDetailsPage.commonfunChangeClk(this);
      });
    } else if (dealTypeForLoad === 'COMBO_FIXED' || dealTypeForLoad === 'COMBO_DISCOUNT') {
      $(document).on('click', '.ph-prodDetailsDeal .ph-list_plusminus', function() {
        ACC.dealDetailsPage.updateQuantityBox($(this).closest('.ph-quantity-input-container').first(), $(this));
      });

      $(document).on('change blur', '.ph-return-qtybox-deal', function() {
        if ($(this).val() === '') {
          $(this).val(0);
        }

        ACC.dealDetailsPage.updateQuantityBox($(this).closest('.ph-quantity-input-container').first(), $(this));
        // ACC.dealDetailsPage.updateSubTotalPrice($(this).closest('.ph-prodDetailsDeal').first());
        ACC.dealDetailsPage.updateTotalSelectedQtyInHeader($(this).closest('.ph-dealsMainProducts').first());
      });

      $(document).on('keyup', '.ph-return-qtybox-deal', function() {
        if (ACC.dealDetailsPage.keypressTimeoutVar) {
          clearTimeout(ACC.dealDetailsPage.keypressTimeoutVar);
          ACC.dealDetailsPage.keypressTimeoutVar = null;
        }

        ACC.dealDetailsPage.$keypressQtyInpEle = $(this);
        ACC.dealDetailsPage.keypressTimeoutVar = setTimeout(function() {
          ACC.dealDetailsPage.$keypressQtyInpEle.trigger('change');
        }, 750);
      });
    }
  }
});

/* eslint-enable max-lines */
/* eslint-enable max-len */
/* eslint-enable complexity */
/* eslint-enable radix */
/* eslint-enable max-statements*/
/* eslint-enable no-negated-condition*/
/* eslint-enable vars-on-top */
/* eslint-enable xss/no-mixed-html */
/* eslint-enable xss/no-location-href-assign */
/* eslint-enable sonarjs/no-identical-functions*/
/* eslint-enable no-ternary */
